import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import {
  Panel,
  Message,
  Grid,
  Row,
  Col,
  Input,
  Nav,
  Icon,
  Uploader,
  ControlLabel,
  Button,
  CheckboxGroup,
  Checkbox,
  DatePicker,
  HelpBlock,
  ButtonToolbar,
  ButtonGroup,
} from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import './styles.less'
import CKEditorBlankFrom from '../../components/forms/input/CKEditorBlankFrom'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import {
  isImageOrPdf,
  isImageOrPdfOrMsFile,
  isRequired,
  isValidators,
  requiredFiled,
} from '../../utils/ValidatorUtils'
import classNames from 'classnames'
import AppContext from '../../context/AppContext'
import InputForm from '../../components/forms/input/InputForm'
import { cloneDeep, isEmpty } from 'lodash-es'
import { budgetFormat } from '../../utils/formatterUtil'
import { DATE_FORMAT, LOCAL_DAY_TH } from '../../constants/date'
import moment from 'moment'
import InformationIncon from '../../components/help/InformationIncon'
import {
  getProgressReportSubprojectClose,
  saveActivitiescost,
  saveActivitiesImage,
  saveActivitiesresult,
} from '../../redux/actions/progressReportSubproject'
import { doneLoading, startLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import SubProjectViewFilesWidget from '../periodicFinancialReportSubProject/SubProjectViewFilesWidget'
import { getDowloadSubProjectFilePath } from '../../redux/actions/subProjectFinancialReport'
import TooltipButton from '../../components/buttons/TooltipButton'
import NumberFormat from 'react-number-format'
import { getDateThaiShortDash, getDateThaiShortDash2 } from '../../utils/dataUtil'
import { useDispatch } from 'react-redux'
import { getSchemaSubProjectDep6Sidebar } from '../../redux/actions/sidebar'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'

export default function ProgressResultsOfOperations({
  schema: _schema,
  isReadOnly,
  isRole,
  renderMentionOfmentor,
  period,
  projectCode,
  projectVersionId,
  installmentPlanId,
  disabled,
  progressReportsId,
  setProgressReportsId = () => {},
  projectStartDate,
  projectEndDate,
  ...props
}) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { theme } = React.useContext(AppContext)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, getValues, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [active, setActive] = useState()
  const [videoItem, setVideoItem] = useState(null)

  const [activitiesItem, setActivitiesItem] = useState()
  const [activitiesIndex, setActivitiesIndex] = useState(0)
  const [activitiesTabSelected, setActivitiesTabSelected] = useState('activitiesResult')
  const defaultSupportType = '.jpg, .jpeg, .png, .pdf'
  const defaultMaxFileSize = 50
  const [fileTypeError, setFileTypeError] = useState(false)

  const [balanceVal, setBalanceVal] = useState(0)
  const [compensationVal, setCompensationVal] = useState(0)
  const [wagesVal, setWagesVal] = useState(0)
  const [expensesVal, setExpensesVal] = useState(0)
  const [materialCostVal, setMaterialCostVal] = useState(0)
  const [utilityCostVal, setUtilityCostVal] = useState(0)
  const [otherVal, setOtherVal] = useState(0)
  const [disableExpenses, setDisableExpenses] = useState(false)
  const [fromAttachFiles, setFromAttachFiles] = useState()
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [isRefash, setIsRefash] = useState(false)
  const projectId = sessionStorage.getItem('projectId')
  const dispatch = useDispatch()
  const [balancePerActivityInputVal, setBalancePerActivityInputVal] = useState(0)
  const [sumBalanceVal, setSumBalanceVal] = useState(0)
  const [commentVal, setcommentVal] = useState()

  // console.log('ยอดรวมค่าใช้จ่าย==>', balanceVal)
  // console.log('งบคงเหลือ==>', balancePerActivityInputVal)
  // console.log('ยอดค่าใช้จ่าย-ยอดคงเหลือ==>', sumBalanceVal)
  // console.log('555', disableExpenses)
  useEffect(() => {
    handleSelect('activitiesResult_0', _schema?.activities[0]?.activitiesDetail, 0)
  }, [_schema])

  useEffect(() => {
    const calculatedValue = balancePerActivityInputVal - balanceVal
    setSumBalanceVal(calculatedValue)
  }, [balanceVal])

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  const onSubmitActivities = (data) => {
    const index = parseInt(data.activitiesResultIndex)

    const actName = formSchema?.activities[index]?.activitiesInput?.label || null
    const actDesc = formSchema?.activities[index]?.activitiesInput?.value || null
    const actRef = formSchema?.activities[index]?.activitiesInput?.valueDef || null

    const request = {
      projectVersionId: projectVersionId || '',
      projectCode: projectCode || '',
      period: period,
      installmentPlanDetailId: installmentPlanId,
      id: formSchema?.activities[index]?.activitiesDetail[0]?.id || null,
      activityName: actName || null,
      activityDescrition: actDesc,
      actualResults: data?.activitiesResult || null,
      activityStartDate: data?.activityStartDate
        ? moment(data.activityStartDate).format('yyyy-MM-DD')
        : null || '',
      activityEndDate: data?.activityEndDate
        ? moment(data.activityEndDate).format('yyyy-MM-DD')
        : null || '',
      location: data?.locationInput || '',
      targetGroup: data?.targetGroupInput || '',
      mentionOfmentor: data?.mentionOfmentor || '',
      activityRefCode: actRef || '',
    }

    handleCallService(request)
  }

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)

    try {
      const response = await saveActivitiesresult(request)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        setProgressReportsId()
        // console.log('55555', response.forms.performanceResults.activities)
        // setcommentVal()
        handleGetSchema()
        await dispatch(getSchemaSubProjectDep6Sidebar(projectId))
      } else {
        notification.open('error', {
          title: response.errorMessage || DEFAULT_ERR_MSG,
        })
      }
    } catch (error) {
      console.error('try catch error ', error)
      notification.open('error', {
        title: error?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleChange = (value) => {
    setBalanceVal(0)
    setDisableExpenses(!disableExpenses)

    if (value != 0) {
      summaryExpen(activitiesItem.expenses)
    }
  }

  const onSubmitBudgetForm = (data, acIndex, strKey) => {
    const index = parseInt(data.activitiesBudgetIndex)

    const actName = formSchema?.activities[index]?.activitiesInput?.label || null
    const actDesc = formSchema?.activities[index]?.activitiesInput?.value || null
    const actRef = formSchema?.activities[index]?.activitiesInput?.valueDef || null

    const formData = new FormData()

    formData.append('ProjectVersionId', projectVersionId || '')
    formData.append('ProjectCode', projectCode || '')
    formData.append('Period', period || '')
    formData.append('InstallmentPlanDetailId', installmentPlanId || '')

    formData.append('SubProjectProgressActivityId', data.activityId || '')
    formData.append('Id', data.activitiesBudgetId || '')
    formData.append('TargetCostAmt', data.budgetInput || 0)
    // formData.append('CompensationCostAmt', data.compensationInput || 0)
    formData.append('CompensationCostAmt', disableExpenses ? 0 : data.compensationInput || 0)
    // formData.append('WagesCostAmt', data.wagesInput || 0)
    formData.append('WagesCostAmt', disableExpenses ? 0 : data.wagesInput || 0)
    // formData.append('ExpensesCostAmt', data.expensesInput || 0)
    formData.append('ExpensesCostAmt', disableExpenses ? 0 : data.expensesInput || 0)
    // formData.append('MaterialCostAmt', data.materialCostInput || 0)
    formData.append('MaterialCostAmt', disableExpenses ? 0 : data.materialCostInput || 0)
    // formData.append('UtilityCostAmt', data.utilityCostsInput || 0)
    formData.append('UtilityCostAmt', disableExpenses ? 0 : data.utilityCostsInput || 0)
    // formData.append('OtherCostAmt', data.otherValuesInput || 0)
    formData.append('OtherCostAmt', disableExpenses ? 0 : data.otherValuesInput || 0)
    formData.append(
      'NoExpenditureOccurred',
      data?.noExpenditureOccurredOption?.length == 2 || false
    )
    formData.append('ActivityName', actName || '')
    formData.append('ActivityDescrition', actDesc || '')
    formData.append('ActivityRefCode', actRef || '')
    // formData.append('BalanceVal', balanceVal || 0)
    formData.append('BalanceVal', disableExpenses ? 0 : balanceVal || 0)
    // formData.append('BalancePerActivity', balancePerActivityInputVal || 0)

    //when disableExpenses set Value = 0
    if (disableExpenses) {
      setValue(activitiesItem.expenses.compensationInput.name, 0)
      setValue(activitiesItem.expenses.wagesInput.name, 0)
      setValue(activitiesItem.expenses.expensesInput.name, 0)
      setValue(activitiesItem.expenses.materialCostInput.name, 0)
      setValue(activitiesItem.expenses.utilityCostsInput.name, 0)
      setValue(activitiesItem.expenses.otherValuesInput.name, 0)
      setBalanceVal(0)
    }

    data.attachFiles &&
      data.attachFiles?.forEach((element) => {
        formData.append('BillFilePath', element.blobFile)
      })

    handleCallServiceBudgetForm(formData, acIndex, strKey)
  }

  const handleCallServiceBudgetForm = async (request, acIndex, strKey) => {
    startLoading()
    setIsLoading(true)
    try {
      const response = await saveActivitiescost(request)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        setProgressReportsId(response.progressReportsId)
        handleGetSchema()
        await dispatch(getSchemaSubProjectDep6Sidebar(projectId))
        handleSelect(
          strKey,
          response?.forms?.performanceResults?.resultsOfOperations?.activities[acIndex]
            ?.activitiesDetail,
          acIndex
        )

        setValue(formSchema.activities[acIndex].activitiesDetail[2].attachFiles.name, [])

        onRefash()
      } else {
        notification.open('error', {
          title: response.errorMessage || DEFAULT_ERR_MSG,
        })
      }
    } catch (error) {
      console.error('try catch error ', error.response)
      notification.open('error', {
        title: error?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
      })
    }

    setIsLoading(false)
    doneLoading()
  }

  const handleGetSchema = async () => {
    startLoading()

    try {
      const response = await getProgressReportSubprojectClose(
        period,
        projectCode,
        projectVersionId,
        installmentPlanId
      )

      if (response) {
        setFormSchema(response.forms.performanceResults.resultsOfOperations)
      }
    } catch (e) {
      console.log(' error', e)
    }
    doneLoading()
  }

  const handleSelect = (activeKey, item, index) => {
    const str = activeKey.split('_')

    var thisSchema = item.find((item) => item.name == str[0])

    setActivitiesIndex(index)
    setActivitiesTabSelected(str[0])
    setActivitiesItem(thisSchema)
    setActive(activeKey)

    if (str[0] == 'activitiesBudget') {
      setBalancePerActivityInputVal(thisSchema.income.balancePerActivityInput.value)

      setValue(
        _schema?.activities[index]?.activitiesDetail[2]?.income?.balancePerActivityInput?.name,
        thisSchema.income.balancePerActivityInput.value
      )
      // budgetInput
      // balancePerActivityInput
      if (thisSchema.noExpenditureOccurredOption.value == 0) {
        setDisableExpenses(true)
        setBalanceVal(0)
      } else {
        setDisableExpenses(false)
        summaryExpen(thisSchema.expenses)
      }
    }

    if (str[0] == 'activitiesImage') {
      callFilsActivitiesImage(thisSchema.attachFiles.values)
      setValue(`activitiesBudgetId`, '')
      setValue(`activityId`, '')

      if (thisSchema?.attachVideo?.value?.length > 0) {
        setVideoItem(thisSchema?.attachVideo?.value)
      } else {
        setVideoItem([
          {
            seqNo: 99,
            name: '',
            link: '',
          },
        ])
      }
    }

    if (str[0] == 'activitiesResult') {
      setStartDate(thisSchema?.activityStartDateInput?.value)
      setEndDate(thisSchema?.activityEndDateInput?.value)
    }
  }

  const CustomNav = ({ active, onSelect, subSchema, tabs = 0, ...props }) => {
    return (
      <>
        <Nav
          justified
          {...props}
          activeKey={active}
          onSelect={onSelect}
          style={{ marginBottom: 30 }}
          // key={tabs}
        >
          {subSchema.map((item, index) => {
            return (
              <Nav.Item eventKey={`${item.name}_${tabs}`} key={index}>
                <b> {item.label}</b>
              </Nav.Item>
            )
          })}
        </Nav>
      </>
    )
  }

  const activitiesResultForm = (activitiesResultSchema, index, activityId) => {
    if (activitiesResultSchema) {
      return (
        <>
          <Panel
            collapsible
            defaultExpanded
            bordered
            style={{ marginTop: -33 }}
            key={`${activitiesResultSchema.name}_${index}_${activitiesResultSchema.id}`}
          >
            <Row>
              <Col lg={24} md={24} sm={24} xs={24}>
                {!disabled ? (
                  <>
                    <Input
                      defaultValue={index}
                      name={'activitiesResultIndex'}
                      inputRef={register}
                      style={{ display: 'none' }}
                    />
                    <CKEditorBlankFrom
                      schema={activitiesResultSchema}
                      value={activitiesResultSchema?.value || ''}
                      // name={`${activitiesResultSchema.name}_${index}_${activitiesResultSchema.id}`}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      hideToolbar={true}
                      noControlLabel={true}
                      rowMarginTop={false}
                      key={`${activitiesResultSchema.name}_${index}`}
                    />
                  </>
                ) : (
                  <>
                    <p dangerouslySetInnerHTML={{ __html: activitiesResultSchema?.value || '' }} />
                  </>
                )}
              </Col>
            </Row>

            <Row style={{ marginTop: 10 }}>
              <Col lg={12} md={12} sm={12} xs={12}>
                {activitiesResultSchema.activityStartDateInput && (
                  <>
                    {!disabled ? (
                      <>
                        <div style={{ marginTop: 14 }}>
                          <ControlLabel
                            className={classNames(
                              isRequired(
                                activitiesResultSchema.activityStartDateInput.validators
                              ) && 'required'
                            )}
                          >
                            {activitiesResultSchema.activityStartDateInput.label}
                          </ControlLabel>
                        </div>
                        {/* <ErrorMessage error={errors.activityStartDateInput} />
                         */}
                        <ErrorMessage
                          error={errors[activitiesResultSchema.activityStartDateInput.name]}
                        />
                        <Controller
                          name={activitiesResultSchema.activityStartDateInput.name}
                          control={control}
                          defaultValue={
                            activitiesResultSchema.activityStartDateInput.value
                              ? moment(
                                  activitiesResultSchema.activityStartDateInput.value,
                                  DATE_FORMAT
                                ).toDate()
                              : null
                          }
                          rules={isValidators(
                            activitiesResultSchema.activityStartDateInput.validators
                          )}
                          render={(props) => {
                            return (
                              <DatePicker
                                format="DD/MM/YYYY"
                                locale={LOCAL_DAY_TH}
                                block
                                placeholder={
                                  'ระบุ' + activitiesResultSchema.activityStartDateInput.label
                                }
                                placement="auto"
                                value={props.value ? props.value : startDate}
                                onChange={(value) => {
                                  props.onChange(value)
                                  setStartDate(value)
                                }}
                                disabledDate={(date) =>
                                  (projectStartDate &&
                                    moment(projectStartDate).isAfter(date, new Date())) ||
                                  (projectEndDate &&
                                    moment(projectEndDate).isBefore(date, new Date())) ||
                                  (endDate && moment(endDate).isBefore(date, new Date()))
                                }
                              />
                            )
                          }}
                        />
                      </>
                    ) : (
                      <div style={{ marginTop: 14 }}>
                        <b>{`${activitiesResultSchema?.activityStartDateInput?.label || ''}`}</b>
                        <p>
                          {`${getDateThaiShortDash2(
                            activitiesResultSchema?.activityStartDateInput?.value
                          )}`}
                        </p>
                      </div>
                    )}
                  </>
                )}
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                {activitiesResultSchema.activityEndDateInput && (
                  <>
                    {!disabled ? (
                      <>
                        <div style={{ marginTop: 14 }}>
                          <ControlLabel
                            className={classNames(
                              isRequired(activitiesResultSchema.activityEndDateInput.validators) &&
                                'required'
                            )}
                          >
                            {activitiesResultSchema.activityEndDateInput.label}
                          </ControlLabel>
                        </div>
                        {/* <ErrorMessage error={errors.activityEndDateInput} /> */}
                        <ErrorMessage
                          error={errors[activitiesResultSchema.activityEndDateInput.name]}
                        />
                        <Controller
                          name={activitiesResultSchema.activityEndDateInput.name}
                          control={control}
                          defaultValue={
                            activitiesResultSchema.activityEndDateInput.value
                              ? moment(
                                  activitiesResultSchema.activityEndDateInput.value,
                                  DATE_FORMAT
                                ).toDate()
                              : null
                          }
                          rules={isValidators(
                            activitiesResultSchema.activityEndDateInput.validators
                          )}
                          render={(props) => {
                            return (
                              <DatePicker
                                format="DD/MM/YYYY"
                                locale={LOCAL_DAY_TH}
                                block
                                placeholder={
                                  'ระบุ' + activitiesResultSchema.activityEndDateInput.label
                                }
                                placement="auto"
                                value={props.value ? props.value : endDate}
                                onChange={(value) => {
                                  props.onChange(value)
                                  setEndDate(value)
                                }}
                                disabledDate={(date) =>
                                  (projectStartDate &&
                                    moment(projectStartDate).isAfter(date, new Date())) ||
                                  (projectEndDate &&
                                    moment(projectEndDate).isBefore(date, new Date())) ||
                                  (startDate && moment(startDate).isAfter(date, new Date()))
                                }
                              />
                            )
                          }}
                        />
                      </>
                    ) : (
                      <div style={{ marginTop: 14 }}>
                        <b>{`${activitiesResultSchema?.activityEndDateInput?.label || ''}`}</b>
                        <p>
                          {`${getDateThaiShortDash2(
                            activitiesResultSchema?.activityEndDateInput?.value
                          )}`}
                        </p>
                      </div>
                    )}
                  </>
                )}
              </Col>
            </Row>

            <Row style={{ marginTop: 10 }}>
              <Col lg={12} md={12} sm={12} xs={12}>
                {activitiesResultSchema.locationInput && (
                  <>
                    {!disabled ? (
                      <>
                        <div style={{ marginTop: 14 }}>
                          <ControlLabel
                            className={classNames(
                              isRequired(activitiesResultSchema.locationInput.validators) &&
                                'required'
                            )}
                          >
                            {activitiesResultSchema.locationInput.label}
                          </ControlLabel>
                        </div>
                        <ErrorMessage error={errors.locationInput} />
                        <Input
                          name={activitiesResultSchema.locationInput.name}
                          defaultValue={activitiesResultSchema.locationInput.value}
                          inputRef={register(
                            isValidators(activitiesResultSchema.locationInput.validators)
                          )}
                          placeholder={'ระบุ' + activitiesResultSchema.locationInput.label}
                        />
                      </>
                    ) : (
                      <div style={{ marginTop: 14 }}>
                        <b>{`${activitiesResultSchema?.locationInput?.label || ''}`}</b>
                        <p>{`${activitiesResultSchema?.locationInput?.value || ''}`}</p>
                      </div>
                    )}
                  </>
                )}
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                {activitiesResultSchema.targetGroupInput && (
                  <>
                    {!disabled ? (
                      <>
                        <div style={{ marginTop: 14 }}>
                          <ControlLabel
                            className={classNames(
                              isRequired(activitiesResultSchema.targetGroupInput.validators) &&
                                'required'
                            )}
                          >
                            {activitiesResultSchema.targetGroupInput.label}
                          </ControlLabel>
                        </div>
                        {/* <ErrorMessage error={errors.targetGroupInput} />
                         */}
                        <ErrorMessage
                          error={errors[activitiesResultSchema.targetGroupInput.name]}
                        />
                        <Input
                          name={activitiesResultSchema.targetGroupInput.name}
                          defaultValue={activitiesResultSchema.targetGroupInput.value}
                          inputRef={register(
                            isValidators(activitiesResultSchema.targetGroupInput.validators)
                          )}
                          placeholder={'ระบุ' + activitiesResultSchema.targetGroupInput.label}
                        />
                      </>
                    ) : (
                      <div style={{ marginTop: 14 }}>
                        <b>{`${activitiesResultSchema?.targetGroupInput?.label || ''}`}</b>
                        <p>{`${activitiesResultSchema?.targetGroupInput?.value || ''}`}</p>
                      </div>
                    )}
                  </>
                )}
              </Col>
            </Row>
            <Row>
              <Col lg={24} md={24} sm={24} xs={24}>
                {renderMentionOfmentor == true && (
                  <>
                    <div style={{ marginTop: 14 }}>
                      <ControlLabel
                        className={classNames(
                          isRequired(activitiesResultSchema.mentionOfmentor.validators) &&
                            'required'
                        )}
                      >
                        {activitiesResultSchema.mentionOfmentor.label}
                      </ControlLabel>
                    </div>
                    <ErrorMessage error={errors.mentionOfmentor} />
                    <InputForm
                      schema={activitiesResultSchema.mentionOfmentor}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      hideLabel={true}
                      componentClass="textarea"
                      //  rows={3}
                    />
                  </>
                )}
              </Col>
            </Row>

            {!disabled && (
              <Row style={{ marginTop: 10 }}>
                <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <SaveButton disabled={isLoading} onClick={handleSubmit(onSubmitActivities)}>
                    {`บันทึก${activitiesResultSchema.label}`}
                  </SaveButton>
                </Col>
              </Row>
            )}
          </Panel>
        </>
      )
    }
  }

  const callFilsActivitiesImage = async (files) => {
    try {
      let attachfiles = []

      for (let index = 0; index < files.length; index++) {
        const element = files[index]

        if (element.path != 'null' && element.path) {
          const response = await getDowloadSubProjectFilePath(element.path)

          if (response && index <= 3) {
            attachfiles.push({ path: element.path, file: response, name: `imge_${index}` })
          }
        } else {
          attachfiles.push({ path: null, file: null, name: null })
        }
      }

      setFromAttachFiles(attachfiles)
    } catch (e) {
      console.log('error callFilsActivitiesImage ', e)
    }
  }

  const onSubmitActivitiesImage = (data, acIndex, strKey) => {
    const index = parseInt(data.activitiesBudgetIndex)

    const actName = formSchema?.activities[index]?.activitiesInput?.label || ''
    const actDesc = formSchema?.activities[index]?.activitiesInput?.value || ''
    const actRef = formSchema?.activities[index]?.activitiesInput?.valueDef || ''

    let attachVideoName = ''
    let attachVideoLink = ''
    if (data?.attachVideoName?.length > 0) {
      attachVideoName = data?.attachVideoName.join(',')
    }

    if (data?.attachVideoLink.length > 0) {
      attachVideoLink = data?.attachVideoLink.join(',')
    }

    // const x = response.forms.performanceResults.resultsOfOperations.activities[
    //   acIndex
    // ].activitiesDetail.find((item) => item.name == 'activitiesImage')
    // setValue(`activityId`, x.id)

    // const xx = response.forms.performanceResults.resultsOfOperations.activities[acIndex]
    // setValue(`activitiesBudgetId`, xx.id)

    const formData = new FormData()

    formData.append('ProjectVersionId', projectVersionId || '')
    formData.append('ProjectCode', projectCode || '')
    formData.append('Period', period || '')
    formData.append('InstallmentPlanDetailId', installmentPlanId || '')

    formData.append('SubProjectProgressActivityId', formSchema?.activities[index]?.id || '')
    formData.append('Id', formSchema?.activities[index]?.activitiesDetail[1]?.id || null)
    formData.append('LinkVdoName', attachVideoName || '')
    formData.append('LinkVdoUrl', attachVideoLink || '')
    formData.append('ActivityName', actName || '')
    formData.append('ActivityDescrition', actDesc || '')
    formData.append('ActivityRefCode', actRef || '')
    data.attachFiles &&
      data.attachFiles?.forEach((element) => {
        formData.append('AttachFiles', element.blobFile)
      })

    let newArr = []
    const thisSchema = formSchema?.activities[index].activitiesDetail.find(
      (item) => item.name == 'activitiesImage'
    )

    if (!data.attachFiles && thisSchema.attachFiles.values.length != 0) {
      for (let index = 0; index < 4; index++) {
        formData.set(`OldAttachFiles[${index}]`, thisSchema.attachFiles.values[index].path || null)
      }
    }

    data.attachFilesEtc &&
      data.attachFilesEtc?.forEach((element) => {
        formData.append('OtherFilePath', element.blobFile)
      })

    // if (data?.attachFilesEtc?.length <= 0 && thisSchema?.attachFilesEtc?.values?.length > 0) {
    //   formData.append('OtherFilePathStr', thisSchema?.attachFilesEtc?.values[0]?.path)
    // }
    if (!data?.attachFilesEtc || data.attachFilesEtc.length <= 0) {
      if (thisSchema?.attachFilesEtc?.values?.length > 0) {
        formData.append('OtherFilePathStr', thisSchema.attachFilesEtc.values[0]?.path)
      }
    }

    handleCallServiceActivitiesImage(formData, acIndex, strKey)
  }

  const handleCallServiceActivitiesImage = async (request, acIndex, strKey) => {
    startLoading()
    setIsLoading(true)

    try {
      const response = await saveActivitiesImage(request)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        setProgressReportsId(response.progressReportsId)
        handleGetSchema()
        await dispatch(getSchemaSubProjectDep6Sidebar(projectId))
        // setFormSchema(response.forms.performanceResults.resultsOfOperations)

        const x = response.forms.performanceResults.resultsOfOperations.activities[
          acIndex
        ].activitiesDetail.find((item) => item.name == 'activitiesImage')
        setValue(`activitiesBudgetId`, x.id)

        const xx = response.forms.performanceResults.resultsOfOperations.activities[acIndex]
        setValue(`activityId`, xx.id)

        handleSelect(
          strKey,
          response?.forms?.performanceResults?.resultsOfOperations?.activities[acIndex]
            ?.activitiesDetail,
          acIndex
        )
        setValue(formSchema.activities[acIndex].activitiesDetail[1].attachFiles.name, null)
        setValue(formSchema.activities[acIndex].activitiesDetail[1].attachFilesEtc.name, null)
      } else {
        notification.open('error', {
          title: response.errorMessage || DEFAULT_ERR_MSG,
        })
      }
    } catch (error) {
      console.error('try catch error ', error)
      notification.open('error', {
        title: error?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
      })
    }

    setIsLoading(false)
    doneLoading()
  }

  const activitiesImageForm = (activitiesImageSchema, index, activityId, strKey) => {
    if (activitiesImageSchema) {
      return (
        <>
          {/* <div style={{ padding: 10 }}> */}
          <Panel collapsible defaultExpanded bordered style={{ marginTop: -33 }}>
            <Row>
              <Col lg={24} md={24} sm={24} xs={24}>
                <Input
                  defaultValue={index}
                  name={'activitiesBudgetIndex'}
                  inputRef={register}
                  style={{ display: 'none' }}
                />
                <Input
                  defaultValue={activitiesImageSchema.id}
                  name={'activitiesBudgetId'}
                  inputRef={register}
                  style={{ display: 'none' }}
                />
                <Input
                  defaultValue={activityId}
                  name={'activityId'}
                  inputRef={register}
                  style={{ display: 'none' }}
                />
                <ErrorMessage error={errors[activitiesImageSchema.attachFiles.name]} />
                {!disabled && (
                  <Controller
                    key={activitiesImageSchema.attachFiles.name}
                    name={activitiesImageSchema.attachFiles.name}
                    control={control}
                    rules={isValidators(activitiesImageSchema.attachFiles.validators)}
                    defaultValue={''}
                    render={(props) => {
                      return (
                        <Uploader
                          accept={
                            activitiesImageSchema.attachFiles.fileType || '.jpg, .jpeg, .png, .gif'
                          }
                          multiple
                          autoUpload={false}
                          disabled={activitiesImageSchema.attachFiles.disabled}
                          fileListVisible={true}
                          listType="picture-text"
                          fileList={props.value || []}
                          onChange={(fileList) => {
                            if (fileList.length > 4) {
                              notification.open('error', {
                                title: 'แนบไฟล์ได้ไม่เกิน 4 ไฟล์',
                                duration: 5000,
                              })

                              return false
                            }

                            if (isEmpty(fileList)) {
                              props.onChange(undefined)
                            } else {
                              let file = fileList[fileList.length - 1]

                              if (
                                file.blobFile.size >
                                (activitiesImageSchema?.attachFiles?.fileSize ||
                                  defaultMaxFileSize) *
                                  1024 *
                                  1024
                              ) {
                                notification.open('error', {
                                  title: `ขนาดไฟล์เกิน ${
                                    activitiesImageSchema.attachFiles.fileSize || defaultMaxFileSize
                                  } MB`,
                                  duration: 5000,
                                })
                                return
                              }

                              if (isImageOrPdf(file.blobFile.type)) {
                                props.onChange(fileList)
                                setFileTypeError(false)
                              } else {
                                setFileTypeError(true)
                                notification.open('error', {
                                  title:
                                    'ชนิดที่รองรับ ' + activitiesImageSchema.attachFiles.fileType ||
                                    '.jpg, .jpeg, .png, .pdf',
                                  duration: 5000,
                                })
                              }
                            }
                          }}
                          draggable
                        >
                          <div>
                            <div
                              style={{ lineHeight: '50px' }}
                              className={classNames('uploader', `${theme[0]}-background`)}
                            >
                              <Icon size="4x" icon="upload2" />
                              <small className="uploder__text">
                                {/* <p style={{ wordBreak: 'break-word' }}>
                                  {`คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด ชนิดที่รองรับ : .jpg, .jpeg, .png, .gif ขนาดไฟล์ไม่เกิน 50 MB`}
                                </p> */}
                                <p style={{ wordBreak: 'break-word' }}>
                                  {`คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด ชนิดที่รองรับ : ${
                                    activitiesImageSchema.attachFiles.fileType ||
                                    '.jpg, .jpeg, .png, .gif'
                                  } , ขนาดไฟล์ไม่เกิน ${
                                    activitiesImageSchema.attachFiles.fileType.fileSize ||
                                    defaultMaxFileSize
                                  } MB`}
                                </p>
                              </small>
                            </div>
                          </div>
                        </Uploader>
                      )
                    }}
                  />
                )}
              </Col>
            </Row>
            <div style={{ marginTop: 10, padding: 20 }}>
              <Row style={{ textAlign: 'center' }}>
                {fromAttachFiles?.length > 0 &&
                  fromAttachFiles.map((item, index) => {
                    let url = null

                    if (item.file) {
                      url = window.URL.createObjectURL(
                        new Blob([item.file], { type: item.file.type })
                      )
                    }

                    return (
                      <>
                        {url ? (
                          <Col lg={6} md={6} sm={6} xs={6}>
                            <div
                              style={{
                                borderStyle: 'solid solid solid solid ',
                                borderWidth: '1px',
                              }}
                            >
                              <h6 style={{ marginTop: 10 }}>{`รูปภาพที่ ${index + 1}`} </h6>
                              <img src={url} style={{ width: '90%', height: 200, marginTop: 5 }} />
                              <ButtonToolbar style={{ marginTop: 5, marginBottom: 5 }}>
                                <ButtonGroup>
                                  <TooltipButton
                                    icon="eye"
                                    tooltip={`แสดง`}
                                    onClick={(_) => handlePreviewFile(item)}
                                  />

                                  <TooltipButton
                                    icon="download"
                                    tooltip={`ดาวน์โหลด`}
                                    onClick={(_) => handleDownloadFile(item)}
                                  />
                                </ButtonGroup>
                              </ButtonToolbar>
                            </div>
                          </Col>
                        ) : (
                          <>
                            <Col lg={6} md={6} sm={6} xs={6}>
                              <div
                                style={{
                                  borderStyle: 'solid solid solid solid ',
                                  borderWidth: '1px',
                                }}
                              >
                                <h6 style={{ marginTop: 10 }}>{`รูปภาพที่ ${index + 1}`} </h6>
                                <div style={{ width: '90%', height: 200, marginTop: 5 }}></div>
                                <ButtonToolbar style={{ marginTop: 5, marginBottom: 5 }}>
                                  <ButtonGroup>
                                    <TooltipButton
                                      disabled={true}
                                      icon="eye"
                                      tooltip={`แสดง`}
                                      onClick={(_) => handlePreviewFile(item)}
                                    />

                                    <TooltipButton
                                      disabled={true}
                                      icon="download"
                                      tooltip={`ดาวน์โหลด`}
                                      onClick={(_) => handleDownloadFile(item)}
                                    />
                                  </ButtonGroup>
                                </ButtonToolbar>
                              </div>
                            </Col>
                          </>
                        )}
                      </>
                    )
                  })}
              </Row>

              <Row style={{ marginTop: 30 }}>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <h4>Link VDO</h4>
                </Col>
              </Row>

              {videoItem.length > 0 &&
                videoItem.map((item, index) => {
                  return (
                    <>
                      <Row>
                        <Col lg={8} md={8} sm={8} xs={8}>
                          {/* ชื่อ vdo  */}
                          {!disabled ? (
                            <InputForm
                              schema={activitiesImageSchema.attachVideo.attachVideoName}
                              name={`${activitiesImageSchema.attachVideo.attachVideoName.name}[${index}]`}
                              placeholder={
                                'ระบุ' + activitiesImageSchema.attachVideo.attachVideoName.label
                              }
                              value={item.name}
                              register={register}
                              Controller={Controller}
                              control={control}
                              errors={errors}
                              setValue={setValue}
                              clearErrors={clearErrors}
                            />
                          ) : (
                            <>
                              <b>{`${
                                activitiesImageSchema?.attachVideo?.attachVideoName.label ||
                                'ชื่อ Video'
                              }`}</b>
                              <p>{`${item?.name || ''}`}</p>
                            </>
                          )}
                        </Col>
                        <Col lg={10} md={10} sm={10} xs={10}>
                          {/* link */}
                          {!disabled ? (
                            <InputForm
                              schema={activitiesImageSchema.attachVideo.attachVideoLink}
                              name={`${activitiesImageSchema.attachVideo.attachVideoLink.name}[${index}]`}
                              placeholder={
                                'ระบุ' + activitiesImageSchema.attachVideo.attachVideoLink.label
                              }
                              value={item.link}
                              register={register}
                              Controller={Controller}
                              control={control}
                              errors={errors}
                              setValue={setValue}
                              clearErrors={clearErrors}
                            />
                          ) : (
                            <>
                              <b>{`${
                                activitiesImageSchema?.attachVideo?.attachVideoLink?.label ||
                                'Link VDO'
                              }`}</b>
                              <p>{`${item?.link || ''}`}</p>
                            </>
                          )}
                        </Col>
                        {!disabled && (
                          <Col lg={4} md={4} sm={4} xs={4}>
                            <div style={{ marginTop: 40 }}>
                              <ButtonToolbar>
                                <Button
                                  color="red"
                                  onClick={() => handleDelObjectVideo(item, index)}
                                  disabled={index == 0 && videoItem?.length == 1}
                                >
                                  ลบ
                                </Button>

                                {videoItem.length == index + 1 && (
                                  <Button onClick={() => handleAddObjectVideo(index)}>เพิ่ม</Button>
                                )}
                              </ButtonToolbar>
                            </div>
                          </Col>
                        )}
                      </Row>
                    </>
                  )
                })}
            </div>
            <Row style={{ marginTop: 10, padding: 20 }}>
              <Col lg={24} md={24} sm={24} xs={24}>
                <ControlLabel>{activitiesImageSchema.attachFilesEtc.header}</ControlLabel>
                <ErrorMessage error={errors[activitiesImageSchema.attachFilesEtc.name]} />

                {!disabled && (
                  <Controller
                    key={activitiesImageSchema.attachFilesEtc.name}
                    name={activitiesImageSchema.attachFilesEtc.name}
                    control={control}
                    // rules={isValidators(activitiesImageSchema.attachFilesEtc.validators)}
                    defaultValue={''}
                    render={(props) => {
                      return (
                        <Uploader
                          accept={
                            activitiesImageSchema.attachFilesEtc.fileType ||
                            '.pdf, .doc, .docx, .xls, .xlsx'
                          }
                          autoUpload={false}
                          disabled={activitiesImageSchema.attachFilesEtc.disabled}
                          fileListVisible={true}
                          listType="picture-text"
                          fileList={props.value || []}
                          onChange={(fileList) => {
                            if (isEmpty(fileList)) {
                              props.onChange(undefined)
                            } else {
                              let file = fileList[fileList.length - 1]
                              if (
                                file.blobFile.size >
                                (activitiesImageSchema.attachFilesEtc?.fileSize ||
                                  defaultMaxFileSize) *
                                  1024 *
                                  1024
                              ) {
                                notification.open('error', {
                                  title: `ขนาดไฟล์เกิน ${
                                    activitiesImageSchema.attachFilesEtc.fileSize ||
                                    defaultMaxFileSize
                                  } MB`,
                                  duration: 5000,
                                })
                                return
                              }
                              if (isImageOrPdfOrMsFile(file.blobFile.type)) {
                                let newArr = []
                                newArr.push(file)
                                props.onChange(newArr)
                                setFileTypeError(false)
                              } else {
                                setFileTypeError(true)
                                notification.open('error', {
                                  title:
                                    'ชนิดที่รองรับ ' +
                                      activitiesImageSchema.attachFilesEtc.fileType ||
                                    '.pdf, .doc, .docx, .xls, .xlsx',
                                  duration: 5000,
                                })
                              }
                            }
                          }}
                          draggable
                        >
                          <div>
                            <div
                              style={{ lineHeight: '50px' }}
                              className={classNames('uploader', `${theme[0]}-background`)}
                            >
                              <Icon size="4x" icon="upload2" />
                              <small className="uploder__text">
                                {/* <p style={{ wordBreak: 'break-word' }}>
                                  {`คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด ชนิดที่รองรับ : .pdf, .doc, .docx, .xls, .xlsx ขนาดไฟล์ไม่เกิน 50 MB`}
                                </p> */}
                                <p style={{ wordBreak: 'break-word' }}>
                                  {`คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด ชนิดที่รองรับ : ${
                                    activitiesImageSchema.attachFilesEtc.fileType ||
                                    '.pdf, .doc, .docx, .xls, .xlsx'
                                  } , ขนาดไฟล์ไม่เกิน ${
                                    activitiesImageSchema.attachFilesEtc.fileType.fileSize ||
                                    defaultMaxFileSize
                                  } MB`}
                                </p>
                              </small>
                            </div>
                          </div>
                        </Uploader>
                      )
                    }}
                  />
                )}

                {activitiesImageSchema.attachFilesEtc.values.length > 0 && (
                  <div style={{ marginTop: 10 }}>
                    <SubProjectViewFilesWidget
                      buttonEye
                      buttonDownload
                      files={activitiesImageSchema.attachFilesEtc.values || []}
                      stringFilesIsNull={`...กรุณา${activitiesImageSchema.attachFilesEtc.header}...`}
                      onPreviewFile={handlePreviewFile}
                      onDownloadFile={handleDownloadFile}
                      defaultName={activitiesImageSchema.attachFilesEtc.header}
                    />
                  </div>
                )}
              </Col>
            </Row>
            {!disabled && (
              <Row style={{ marginTop: 20 }}>
                <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <SaveButton
                    disabled={isLoading}
                    // onClick={handleSubmit(onSubmitActivitiesImage)}
                    onClick={handleSubmit((data) => onSubmitActivitiesImage(data, index, strKey))}
                  >{`บันทึก`}</SaveButton>
                </Col>
              </Row>
            )}
          </Panel>
          {/* </div> */}
        </>
      )
    }
  }

  const handleAddObjectVideo = (index) => {
    let objVideo = cloneDeep(videoItem)

    objVideo.push({
      seqNo: 99,
      name: '',
      link: '',
    })

    setVideoItem(objVideo)
  }

  const handleDelObjectVideo = (item, index) => {
    let objVideo = cloneDeep(videoItem)
    if (index > -1) {
      objVideo.splice(index, 1)
    }

    setVideoItem(objVideo)
  }

  const summaryExpen = (expSchema) => {
    console.log('expSchema', expSchema)
    const compensation = expSchema?.compensationInput?.value || 0 //ค่าตอบแทน
    const wages = expSchema?.wagesInput?.value || 0 //ค่าจ้าง
    const expenses = expSchema?.expensesInput?.value || 0 //ค่าใช้สอย
    const materialCost = expSchema?.materialCostInput?.value || 0 //ค่าวัสดุ
    const utilityCost = expSchema?.utilityCostsInput?.value || 0 //ค่าสาธารณูปโภค
    const other = expSchema?.otherValuesInput?.value || 0 //ค่าสาธารณูปโภค

    setCompensationVal(compensation)
    setWagesVal(wages)
    setExpensesVal(expenses)
    setMaterialCostVal(materialCost)
    setUtilityCostVal(utilityCost)
    setOtherVal(other)

    const total = compensation + wages + expenses + materialCost + utilityCost + other

    setBalanceVal(total)
  }

  const handleChangeValue = (type, val) => {
    let total = 0,
      com = parseFloat(compensationVal || 0),
      wag = parseFloat(wagesVal || 0),
      exp = parseFloat(expensesVal || 0),
      mat = parseFloat(materialCostVal || 0),
      uti = parseFloat(utilityCostVal || 0),
      oth = parseFloat(otherVal || 0),
      newVal = parseFloat(val || 0)

    if (type == 'compensationInput') {
      total = wag + exp + mat + uti + oth + newVal
    } else if (type == 'wagesInput') {
      total = com + exp + mat + uti + oth + newVal
    } else if (type == 'expensesInput') {
      total = com + wag + mat + uti + oth + newVal
    } else if (type == 'materialCostInput') {
      total = com + wag + exp + uti + oth + newVal
    } else if (type == 'utilityCostsInput') {
      total = com + wag + exp + mat + oth + newVal
    } else if (type == 'otherValuesInput') {
      total = com + wag + exp + mat + uti + newVal
    }

    setBalanceVal(total)
  }

  const activitiesBudgetForm = (activitiesBudgetSchema, index, activityId, strKey) => {
    if (activitiesBudgetSchema) {
      return (
        <>
          <Panel
            collapsible
            defaultExpanded
            bordered
            style={{ marginTop: -33 }}
            key={`${activitiesBudgetSchema.name}_${index}_${activitiesBudgetSchema.id}`}
          >
            <Row style={{ marginTop: 20, marginBottom: 20 }}>
              <Col lg={6} md={6} sm={6} xs={6}></Col>
              <Col lg={18} md={18} sm={18} xs={18}>
                <Input
                  defaultValue={index}
                  name={'activitiesBudgetIndex'}
                  inputRef={register}
                  style={{ display: 'none' }}
                />

                <Controller
                  name={activitiesBudgetSchema.noExpenditureOccurredOption.name}
                  control={control}
                  defaultValue={() => {
                    let newArr = []
                    newArr.push(parseInt(activitiesBudgetSchema.noExpenditureOccurredOption.value))
                    return newArr
                  }}
                  render={(props) => {
                    return (
                      <CheckboxGroup
                        name={activitiesBudgetSchema.noExpenditureOccurredOption.name}
                        // value={props.value}
                        defaultValue={props.value}
                        // onChange={handleChange}
                        onChange={(value) => {
                          props.onChange(value)
                          handleChange(value[0])
                        }}
                        inline
                      >
                        {activitiesBudgetSchema.noExpenditureOccurredOption.options.map(
                          (item, index) => {
                            return (
                              <Checkbox value={item.value} disabled={item.disabled} key={index}>
                                <b>{item.label}</b>
                              </Checkbox>
                            )
                          }
                        )}
                      </CheckboxGroup>
                    )
                  }}
                />
              </Col>
            </Row>
            <div style={{ paddingLeft: 45, paddingRight: 45 }}>
              {activitiesBudgetSchema.income && (
                <>
                  <Row>
                    <Col lg={24} md={24} sm={24} xs={24}>
                      <h5 style={{ color: '#2da888' }}>{activitiesBudgetSchema.income.title}</h5>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={2} md={2} sm={2} xs={2}></Col>
                    <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
                      <div style={{ marginTop: 14 }}>
                        {isReadOnly != true ? (
                          <ControlLabel
                            className={classNames(
                              isRequired(activitiesBudgetSchema.income.budgetInput.validators) &&
                                'required'
                            )}
                          >
                            {activitiesBudgetSchema.income.budgetInput.label}
                          </ControlLabel>
                        ) : (
                          <ControlLabel>
                            {activitiesBudgetSchema.income.budgetInput.label}
                          </ControlLabel>
                        )}
                      </div>
                    </Col>
                    {isReadOnly != true ? (
                      <Col lg={14} md={14} sm={14} xs={14}>
                        {/* <InputForm
                          schema={activitiesBudgetSchema.income.budgetInput}
                          // value={item.link}
                          // name={`${activitiesBudgetSchema.name}_${index}_${activitiesBudgetSchema.id}`}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                          hideLabel={true}
                          isInputNumber
                          inputStyle={{ textAlign: 'right' }}
                          disabled
                        /> */}
                        <Controller
                          name={activitiesBudgetSchema.income.budgetInput.name}
                          control={control}
                          defaultValue={activitiesBudgetSchema.income.budgetInput.value || 0}
                          rules={isValidators(activitiesBudgetSchema.income.budgetInput.validators)}
                          render={(props) => {
                            return (
                              <NumberFormat
                                className={classNames(
                                  'rs-input',
                                  errors[activitiesBudgetSchema.income.budgetInput.name] &&
                                    'is-error'
                                )}
                                style={{
                                  textAlign: 'right',
                                  fontWeight: 'bold',
                                  color: '#000000',
                                }}
                                thousandSeparator={true}
                                decimalScale={2}
                                fixedDecimalScale
                                value={props.value}
                                onValueChange={(value) => {
                                  props.onChange(value.floatValue)
                                  setCompensationVal(value.floatValue)
                                  handleChangeValue('compensationInput', value.floatValue)
                                }}
                                disabled
                              />
                            )
                          }}
                        />
                      </Col>
                    ) : (
                      <Col
                        lg={16}
                        md={16}
                        sm={16}
                        xs={16}
                        style={{ marginTop: 10, textAlign: 'right' }}
                      >
                        <span>{` ${budgetFormat(
                          activitiesBudgetSchema.income.budgetInput.value
                        )}`}</span>
                      </Col>
                    )}
                    <Col lg={2} md={2} sm={2} xs={2}>
                      <div style={{ marginTop: 14 }}>{activitiesBudgetSchema.income.unitText}</div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={2} md={2} sm={2} xs={2}></Col>
                    <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
                      <div style={{ marginTop: 14 }}>
                        {isReadOnly != true ? (
                          <ControlLabel
                            className={classNames(
                              isRequired(
                                activitiesBudgetSchema.income.balancePerActivityInput.validators
                              ) && 'required'
                            )}
                          >
                            {activitiesBudgetSchema.income.balancePerActivityInput.label}
                          </ControlLabel>
                        ) : (
                          <ControlLabel>
                            {activitiesBudgetSchema.income.balancePerActivityInput.label}
                          </ControlLabel>
                        )}
                      </div>
                    </Col>
                    {isReadOnly != true ? (
                      <Col lg={14} md={14} sm={14} xs={14}>
                        {/* <Controller
                          name={activitiesBudgetSchema.income.balancePerActivityInput.name}
                          control={control}
                          defaultValue={
                            activitiesBudgetSchema.income.balancePerActivityInput.value || 0
                          }
                          rules={isValidators(
                            activitiesBudgetSchema.income.balancePerActivityInput.validators
                          )}
                          render={(props) => {
                            return (
                              <NumberFormat
                                className={classNames(
                                  'rs-input',
                                  errors[
                                    activitiesBudgetSchema.income.balancePerActivityInput.name
                                  ] && 'is-error'
                                )}
                                style={{
                                  textAlign: 'right',
                                  fontWeight: 'bold',
                                  color: '#000000',
                                }}
                                thousandSeparator={true}
                                decimalScale={2}
                                fixedDecimalScale
                                value={props.value}
                                onValueChange={(value) => {
                                  props.onChange(value.floatValue)
                                  setSumBalanceVal(value.floatValue)
                                  // handleChangeValue2('compensationInput', value.floatValue)
                                }}
                                disabled
                              />
                            )
                          }}
                        /> */}
                        <Controller
                          name={activitiesBudgetSchema.income.balancePerActivityInput.name}
                          control={control}
                          defaultValue={
                            activitiesBudgetSchema.income.balancePerActivityInput.value || 0
                          }
                          rules={isValidators(
                            activitiesBudgetSchema.income.balancePerActivityInput.validators
                          )}
                          render={(props) => {
                            // ใช้ props ตามรูปแบบเดิมที่คุณใช้ในโค้ดแรก
                            return (
                              <NumberFormat
                                className={classNames(
                                  'rs-input',
                                  errors[
                                    activitiesBudgetSchema.income.balancePerActivityInput.name
                                  ] && 'is-error'
                                )}
                                style={{
                                  textAlign: 'right',
                                  fontWeight: 'bold',
                                  color: '#000000',
                                }}
                                thousandSeparator={true}
                                decimalScale={2}
                                fixedDecimalScale
                                value={props.value}
                                onValueChange={(value) => {
                                  console.log('props===>', props.value)
                                  props.onChange(value.floatValue)
                                  setSumBalanceVal(value.floatValue)
                                }}
                                disabled
                              />
                            )
                          }}
                        />
                      </Col>
                    ) : (
                      <Col
                        lg={16}
                        md={16}
                        sm={16}
                        xs={16}
                        style={{ marginTop: 10, textAlign: 'right' }}
                      >
                        <span>{` ${budgetFormat(
                          activitiesBudgetSchema.income.balancePerActivityInput.value
                        )}`}</span>
                      </Col>
                    )}
                    <Col lg={2} md={2} sm={2} xs={2}>
                      <div style={{ marginTop: 14 }}>{activitiesBudgetSchema.income.unitText}</div>
                    </Col>
                  </Row>
                </>
              )}

              {activitiesBudgetSchema.expenses && (
                <>
                  <Row>
                    <Col lg={24} md={24} sm={24} xs={24}>
                      <h5 style={{ color: '#2da888' }}>{activitiesBudgetSchema.expenses.title}</h5>
                      <Input
                        defaultValue={activitiesBudgetSchema.id}
                        name={'activitiesBudgetId'}
                        inputRef={register}
                        style={{ display: 'none' }}
                      />
                      <Input
                        defaultValue={activityId}
                        name={'activityId'}
                        inputRef={register}
                        style={{ display: 'none' }}
                      />
                    </Col>
                  </Row>
                  {/* {!disableExpenses && ( */}
                  <>
                    <div>
                      <Row>
                        {/* <Col lg={2} md={2} sm={2} xs={2}></Col> */}
                        <Col lg={8} md={8} sm={8} xs={8} style={{ textAlign: 'right' }}>
                          <div style={{ marginTop: 14 }}>
                            {activitiesBudgetSchema.expenses.compensationInput.buttonInfo && (
                              <InformationIncon
                                message={
                                  activitiesBudgetSchema.expenses.compensationInput.buttonInfo
                                }
                              />
                            )}
                            {isReadOnly != true ? (
                              <ControlLabel
                                className={classNames(
                                  isRequired(
                                    activitiesBudgetSchema.expenses.compensationInput.validators
                                  ) && 'required'
                                )}
                              >
                                {activitiesBudgetSchema.expenses.compensationInput.label}
                              </ControlLabel>
                            ) : (
                              <ControlLabel>
                                {activitiesBudgetSchema.expenses.compensationInput.label}
                              </ControlLabel>
                            )}
                          </div>
                        </Col>
                        {isReadOnly != true ? (
                          <Col lg={14} md={14} sm={14} xs={14}>
                            {!disableExpenses ? (
                              <>
                                <Controller
                                  name={activitiesBudgetSchema.expenses.compensationInput.name}
                                  control={control}
                                  defaultValue={
                                    activitiesBudgetSchema.expenses.compensationInput.value || 0
                                  }
                                  rules={isValidators(
                                    activitiesBudgetSchema.expenses.compensationInput.validators
                                  )}
                                  render={(props) => {
                                    return (
                                      <NumberFormat
                                        className={classNames(
                                          'rs-input',
                                          errors[
                                            activitiesBudgetSchema.expenses.compensationInput.name
                                          ] && 'is-error'
                                        )}
                                        style={{
                                          textAlign: 'right',
                                        }}
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale
                                        value={props.value}
                                        onValueChange={(value) => {
                                          var val = value.floatValue || 0
                                          props.onChange(val)
                                          setCompensationVal(val)
                                          handleChangeValue('compensationInput', val)
                                        }}
                                        disabled={disabled}
                                        allowNegative={false}
                                      />
                                    )
                                  }}
                                />
                              </>
                            ) : (
                              <>
                                <Controller
                                  name={activitiesBudgetSchema.expenses.compensationInput.name}
                                  control={control}
                                  defaultValue={0}
                                  rules={isValidators(
                                    activitiesBudgetSchema.expenses.compensationInput.validators
                                  )}
                                  render={(props) => {
                                    return (
                                      <NumberFormat
                                        className={classNames(
                                          'rs-input',
                                          errors[
                                            activitiesBudgetSchema.expenses.compensationInput.name
                                          ] && 'is-error'
                                        )}
                                        style={{
                                          textAlign: 'right',
                                        }}
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale
                                        value={0}
                                        disabled
                                        allowNegative={false}
                                      />
                                    )
                                  }}
                                />
                              </>
                            )}
                          </Col>
                        ) : (
                          <Col
                            lg={14}
                            md={14}
                            sm={14}
                            xs={14}
                            style={{ marginTop: 10, textAlign: 'right' }}
                          >
                            <span>{` ${budgetFormat(
                              activitiesBudgetSchema.expenses.compensationInput.value
                            )}`}</span>
                          </Col>
                        )}
                        <Col lg={2} md={2} sm={2} xs={2}>
                          <div style={{ marginTop: 14 }}>
                            {activitiesBudgetSchema.expenses.unitText}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        {/* <Col lg={2} md={2} sm={2} xs={2}></Col> */}
                        <Col lg={8} md={8} sm={8} xs={8} style={{ textAlign: 'right' }}>
                          <div style={{ marginTop: 14 }}>
                            {activitiesBudgetSchema.expenses.wagesInput.buttonInfo && (
                              <InformationIncon
                                message={activitiesBudgetSchema.expenses.wagesInput.buttonInfo}
                              />
                            )}
                            {isReadOnly != true ? (
                              <ControlLabel
                                className={classNames(
                                  isRequired(
                                    activitiesBudgetSchema.expenses.wagesInput.validators
                                  ) && 'required'
                                )}
                              >
                                {activitiesBudgetSchema.expenses.wagesInput.label}
                              </ControlLabel>
                            ) : (
                              <ControlLabel>
                                {activitiesBudgetSchema.expenses.wagesInput.label}
                              </ControlLabel>
                            )}
                          </div>
                        </Col>
                        {isReadOnly != true ? (
                          <Col lg={14} md={14} sm={14} xs={14}>
                            {!disableExpenses ? (
                              <>
                                <Controller
                                  name={activitiesBudgetSchema.expenses.wagesInput.name}
                                  control={control}
                                  defaultValue={
                                    activitiesBudgetSchema.expenses.wagesInput.value || 0
                                  }
                                  rules={isValidators(
                                    activitiesBudgetSchema.expenses.wagesInput.validators
                                  )}
                                  render={(props) => {
                                    return (
                                      <NumberFormat
                                        className={classNames(
                                          'rs-input',
                                          errors[activitiesBudgetSchema.expenses.wagesInput.name] &&
                                            'is-error'
                                        )}
                                        style={{
                                          textAlign: 'right',
                                        }}
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale
                                        value={props.value}
                                        onValueChange={(value) => {
                                          props.onChange(value.floatValue)
                                          setWagesVal(value.floatValue)
                                          handleChangeValue('wagesInput', value.floatValue)
                                        }}
                                        disabled={disabled}
                                        allowNegative={false}
                                      />
                                    )
                                  }}
                                />
                              </>
                            ) : (
                              <>
                                <Controller
                                  name={activitiesBudgetSchema.expenses.wagesInput.name}
                                  control={control}
                                  defaultValue={0}
                                  rules={isValidators(
                                    activitiesBudgetSchema.expenses.wagesInput.validators
                                  )}
                                  render={(props) => {
                                    return (
                                      <NumberFormat
                                        className={classNames(
                                          'rs-input',
                                          errors[activitiesBudgetSchema.expenses.wagesInput.name] &&
                                            'is-error'
                                        )}
                                        style={{
                                          textAlign: 'right',
                                        }}
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale
                                        value={0}
                                        // onValueChange={(value) => {
                                        //   props.onChange(value.floatValue)
                                        //   setWagesVal(value.floatValue)
                                        //   handleChangeValue('wagesInput', value.floatValue)
                                        // }}
                                        disabled
                                        allowNegative={false}
                                      />
                                    )
                                  }}
                                />
                              </>
                            )}
                          </Col>
                        ) : (
                          <Col
                            lg={14}
                            md={14}
                            sm={14}
                            xs={14}
                            style={{ marginTop: 10, textAlign: 'right' }}
                          >
                            <span>{` ${budgetFormat(
                              activitiesBudgetSchema.expenses.wagesInput.value
                            )}`}</span>
                          </Col>
                        )}
                        <Col lg={2} md={2} sm={2} xs={2}>
                          <div style={{ marginTop: 14 }}>
                            {activitiesBudgetSchema.expenses.unitText}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        {/* <Col lg={2} md={2} sm={2} xs={2}></Col> */}
                        <Col lg={8} md={8} sm={8} xs={8} style={{ textAlign: 'right' }}>
                          <div style={{ marginTop: 14 }}>
                            {activitiesBudgetSchema.expenses.expensesInput.buttonInfo && (
                              <InformationIncon
                                message={activitiesBudgetSchema.expenses.expensesInput.buttonInfo}
                              />
                            )}
                            {isReadOnly != true ? (
                              <ControlLabel
                                className={classNames(
                                  isRequired(
                                    activitiesBudgetSchema.expenses.expensesInput.validators
                                  ) && 'required'
                                )}
                              >
                                {activitiesBudgetSchema.expenses.expensesInput.label}
                              </ControlLabel>
                            ) : (
                              <ControlLabel>
                                {activitiesBudgetSchema.expenses.expensesInput.label}
                              </ControlLabel>
                            )}
                          </div>
                        </Col>
                        {isReadOnly != true ? (
                          <Col lg={14} md={14} sm={14} xs={14}>
                            {!disableExpenses ? (
                              <>
                                <Controller
                                  name={activitiesBudgetSchema.expenses.expensesInput.name}
                                  control={control}
                                  defaultValue={
                                    activitiesBudgetSchema.expenses.expensesInput.value || 0
                                  }
                                  rules={isValidators(
                                    activitiesBudgetSchema.expenses.expensesInput.validators
                                  )}
                                  render={(props) => {
                                    return (
                                      <NumberFormat
                                        className={classNames(
                                          'rs-input',
                                          errors[
                                            activitiesBudgetSchema.expenses.expensesInput.name
                                          ] && 'is-error'
                                        )}
                                        style={{
                                          textAlign: 'right',
                                        }}
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale
                                        value={props.value}
                                        onValueChange={(value) => {
                                          props.onChange(value.floatValue)
                                          setExpensesVal(value.floatValue)
                                          handleChangeValue('expensesInput', value.floatValue)
                                        }}
                                        disabled={disabled}
                                        allowNegative={false}
                                      />
                                    )
                                  }}
                                />
                              </>
                            ) : (
                              <>
                                <Controller
                                  name={activitiesBudgetSchema.expenses.expensesInput.name}
                                  control={control}
                                  defaultValue={0}
                                  rules={isValidators(
                                    activitiesBudgetSchema.expenses.expensesInput.validators
                                  )}
                                  render={(props) => {
                                    return (
                                      <NumberFormat
                                        className={classNames(
                                          'rs-input',
                                          errors[
                                            activitiesBudgetSchema.expenses.expensesInput.name
                                          ] && 'is-error'
                                        )}
                                        style={{
                                          textAlign: 'right',
                                        }}
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale
                                        value={0}
                                        // onValueChange={(value) => {
                                        //   props.onChange(value.floatValue)
                                        //   setExpensesVal(value.floatValue)
                                        //   handleChangeValue('expensesInput', value.floatValue)
                                        // }}
                                        disabled
                                        allowNegative={false}
                                      />
                                    )
                                  }}
                                />
                              </>
                            )}
                          </Col>
                        ) : (
                          <Col
                            lg={14}
                            md={14}
                            sm={14}
                            xs={14}
                            style={{ marginTop: 10, textAlign: 'right' }}
                          >
                            <span>{` ${budgetFormat(
                              activitiesBudgetSchema.expenses.wagesInput.value
                            )}`}</span>
                          </Col>
                        )}
                        <Col lg={2} md={2} sm={2} xs={2}>
                          <div style={{ marginTop: 14 }}>
                            {activitiesBudgetSchema.expenses.unitText}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        {/* <Col lg={2} md={2} sm={2} xs={2}></Col> */}
                        <Col lg={8} md={8} sm={8} xs={8} style={{ textAlign: 'right' }}>
                          <div style={{ marginTop: 14 }}>
                            {activitiesBudgetSchema.expenses.materialCostInput.buttonInfo && (
                              <InformationIncon
                                message={
                                  activitiesBudgetSchema.expenses.materialCostInput.buttonInfo
                                }
                              />
                            )}
                            {isReadOnly != true ? (
                              <ControlLabel
                                className={classNames(
                                  isRequired(
                                    activitiesBudgetSchema.expenses.materialCostInput.validators
                                  ) && 'required'
                                )}
                              >
                                {activitiesBudgetSchema.expenses.materialCostInput.label}
                              </ControlLabel>
                            ) : (
                              <ControlLabel>
                                {activitiesBudgetSchema.expenses.materialCostInput.label}
                              </ControlLabel>
                            )}
                          </div>
                        </Col>
                        {isReadOnly != true ? (
                          <Col lg={14} md={14} sm={14} xs={14}>
                            {!disableExpenses ? (
                              <>
                                <Controller
                                  name={activitiesBudgetSchema.expenses.materialCostInput.name}
                                  control={control}
                                  defaultValue={
                                    activitiesBudgetSchema.expenses.materialCostInput.value || 0
                                  }
                                  rules={isValidators(
                                    activitiesBudgetSchema.expenses.materialCostInput.validators
                                  )}
                                  render={(props) => {
                                    return (
                                      <NumberFormat
                                        className={classNames(
                                          'rs-input',
                                          errors[
                                            activitiesBudgetSchema.expenses.materialCostInput.name
                                          ] && 'is-error'
                                        )}
                                        style={{
                                          textAlign: 'right',
                                        }}
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale
                                        value={props.value}
                                        onValueChange={(value) => {
                                          props.onChange(value.floatValue)
                                          setMaterialCostVal(value.floatValue)
                                          handleChangeValue('materialCostInput', value.floatValue)
                                        }}
                                        disabled={disabled}
                                        allowNegative={false}
                                      />
                                    )
                                  }}
                                />
                              </>
                            ) : (
                              <>
                                <Controller
                                  name={activitiesBudgetSchema.expenses.materialCostInput.name}
                                  control={control}
                                  defaultValue={0}
                                  rules={isValidators(
                                    activitiesBudgetSchema.expenses.materialCostInput.validators
                                  )}
                                  render={(props) => {
                                    return (
                                      <NumberFormat
                                        className={classNames(
                                          'rs-input',
                                          errors[
                                            activitiesBudgetSchema.expenses.materialCostInput.name
                                          ] && 'is-error'
                                        )}
                                        style={{
                                          textAlign: 'right',
                                        }}
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale
                                        value={0}
                                        // onValueChange={(value) => {
                                        //   props.onChange(value.floatValue)
                                        //  setMaterialCostVal(value.floatValue)
                                        //   handleChangeValue('materialCostInput', value.floatValue)
                                        // }}
                                        disabled
                                        allowNegative={false}
                                      />
                                    )
                                  }}
                                />
                              </>
                            )}
                          </Col>
                        ) : (
                          <Col
                            lg={14}
                            md={14}
                            sm={14}
                            xs={14}
                            style={{ marginTop: 10, textAlign: 'right' }}
                          >
                            <span>{` ${budgetFormat(
                              activitiesBudgetSchema.expenses.materialCostInput.value
                            )}`}</span>
                          </Col>
                        )}
                        <Col lg={2} md={2} sm={2} xs={2}>
                          <div style={{ marginTop: 14 }}>
                            {activitiesBudgetSchema.expenses.unitText}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        {/* <Col lg={2} md={2} sm={2} xs={2}></Col> */}
                        <Col lg={8} md={8} sm={8} xs={8} style={{ textAlign: 'right' }}>
                          <div style={{ marginTop: 14 }}>
                            {activitiesBudgetSchema.expenses.utilityCostsInput.buttonInfo && (
                              <InformationIncon
                                message={
                                  activitiesBudgetSchema.expenses.utilityCostsInput.buttonInfo
                                }
                              />
                            )}
                            {isReadOnly != true ? (
                              <ControlLabel
                                className={classNames(
                                  isRequired(
                                    activitiesBudgetSchema.expenses.utilityCostsInput.validators
                                  ) && 'required'
                                )}
                              >
                                {activitiesBudgetSchema.expenses.utilityCostsInput.label}
                              </ControlLabel>
                            ) : (
                              <ControlLabel>
                                {activitiesBudgetSchema.expenses.utilityCostsInput.label}
                              </ControlLabel>
                            )}
                          </div>
                        </Col>
                        {isReadOnly != true ? (
                          <Col lg={14} md={14} sm={14} xs={14}>
                            {!disableExpenses ? (
                              <>
                                <Controller
                                  name={activitiesBudgetSchema.expenses.utilityCostsInput.name}
                                  control={control}
                                  defaultValue={
                                    activitiesBudgetSchema.expenses.utilityCostsInput.value || 0
                                  }
                                  rules={isValidators(
                                    activitiesBudgetSchema.expenses.utilityCostsInput.validators
                                  )}
                                  render={(props) => {
                                    return (
                                      <NumberFormat
                                        className={classNames(
                                          'rs-input',
                                          errors[
                                            activitiesBudgetSchema.expenses.utilityCostsInput.name
                                          ] && 'is-error'
                                        )}
                                        style={{
                                          textAlign: 'right',
                                        }}
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale
                                        value={props.value}
                                        onValueChange={(value) => {
                                          props.onChange(value.floatValue)
                                          setUtilityCostVal(value.floatValue)
                                          handleChangeValue('utilityCostsInput', value.floatValue)
                                        }}
                                        disabled={disabled}
                                        allowNegative={false}
                                      />
                                    )
                                  }}
                                />
                              </>
                            ) : (
                              <>
                                <Controller
                                  name={activitiesBudgetSchema.expenses.utilityCostsInput.name}
                                  control={control}
                                  defaultValue={0}
                                  rules={isValidators(
                                    activitiesBudgetSchema.expenses.utilityCostsInput.validators
                                  )}
                                  render={(props) => {
                                    return (
                                      <NumberFormat
                                        className={classNames(
                                          'rs-input',
                                          errors[
                                            activitiesBudgetSchema.expenses.utilityCostsInput.name
                                          ] && 'is-error'
                                        )}
                                        style={{
                                          textAlign: 'right',
                                        }}
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale
                                        value={0}
                                        // onValueChange={(value) => {
                                        //   props.onChange(value.floatValue)
                                        //  setUtilityCostVal(value.floatValue)
                                        //   handleChangeValue('utilityCostsInput', value.floatValue)
                                        // }}
                                        disabled
                                        allowNegative={false}
                                      />
                                    )
                                  }}
                                />
                              </>
                            )}
                          </Col>
                        ) : (
                          <Col
                            lg={14}
                            md={14}
                            sm={14}
                            xs={14}
                            style={{ marginTop: 10, textAlign: 'right' }}
                          >
                            <span>{` ${budgetFormat(
                              activitiesBudgetSchema.expenses.utilityCostsInput.value
                            )}`}</span>
                          </Col>
                        )}
                        <Col lg={2} md={2} sm={2} xs={2}>
                          <div style={{ marginTop: 14 }}>
                            {activitiesBudgetSchema.expenses.unitText}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        {/* <Col lg={2} md={2} sm={2} xs={2}></Col> */}
                        <Col lg={8} md={8} sm={8} xs={8} style={{ textAlign: 'right' }}>
                          <div style={{ marginTop: 14 }}>
                            {activitiesBudgetSchema.expenses.otherValuesInput.buttonInfo && (
                              <InformationIncon
                                message={
                                  activitiesBudgetSchema.expenses.otherValuesInput.buttonInfo
                                }
                              />
                            )}
                            {isReadOnly != true ? (
                              <ControlLabel
                                className={classNames(
                                  isRequired(
                                    activitiesBudgetSchema.expenses.otherValuesInput.validators
                                  ) && 'required'
                                )}
                              >
                                {activitiesBudgetSchema.expenses.otherValuesInput.label}
                              </ControlLabel>
                            ) : (
                              <ControlLabel>
                                {activitiesBudgetSchema.expenses.otherValuesInput.label}
                              </ControlLabel>
                            )}
                          </div>
                        </Col>
                        {isReadOnly != true ? (
                          <Col lg={14} md={14} sm={14} xs={14}>
                            {!disableExpenses ? (
                              <>
                                <Controller
                                  name={activitiesBudgetSchema.expenses.otherValuesInput.name}
                                  control={control}
                                  defaultValue={
                                    activitiesBudgetSchema.expenses.otherValuesInput.value || 0
                                  }
                                  rules={isValidators(
                                    activitiesBudgetSchema.expenses.otherValuesInput.validators
                                  )}
                                  render={(props) => {
                                    return (
                                      <NumberFormat
                                        className={classNames(
                                          'rs-input',
                                          errors[
                                            activitiesBudgetSchema.expenses.otherValuesInput.name
                                          ] && 'is-error'
                                        )}
                                        style={{
                                          textAlign: 'right',
                                        }}
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale
                                        value={props.value}
                                        onValueChange={(value) => {
                                          props.onChange(value.floatValue)
                                          setOtherVal(value.floatValue)
                                          handleChangeValue('otherValuesInput', value.floatValue)
                                        }}
                                        disabled={disabled}
                                        allowNegative={false}
                                      />
                                    )
                                  }}
                                />
                              </>
                            ) : (
                              <>
                                <Controller
                                  name={activitiesBudgetSchema.expenses.otherValuesInput.name}
                                  control={control}
                                  defaultValue={0}
                                  rules={isValidators(
                                    activitiesBudgetSchema.expenses.otherValuesInput.validators
                                  )}
                                  render={(props) => {
                                    return (
                                      <NumberFormat
                                        className={classNames(
                                          'rs-input',
                                          errors[
                                            activitiesBudgetSchema.expenses.otherValuesInput.name
                                          ] && 'is-error'
                                        )}
                                        style={{
                                          textAlign: 'right',
                                        }}
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale
                                        value={0}
                                        // onValueChange={(value) => {
                                        //   props.onChange(value.floatValue)
                                        //  setOtherVal(value.floatValue)
                                        //   handleChangeValue('otherValuesInput', value.floatValue)
                                        // }}
                                        disabled
                                        allowNegative={false}
                                      />
                                    )
                                  }}
                                />
                              </>
                            )}
                          </Col>
                        ) : (
                          <Col
                            lg={14}
                            md={14}
                            sm={14}
                            xs={14}
                            style={{ marginTop: 10, textAlign: 'right' }}
                          >
                            <span>{` ${budgetFormat(
                              activitiesBudgetSchema.expenses.otherValuesInput.value
                            )}`}</span>
                          </Col>
                        )}
                        <Col lg={2} md={2} sm={2} xs={2}>
                          <div style={{ marginTop: 14 }}>
                            {activitiesBudgetSchema.expenses.unitText}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </>
                  {/* )} */}

                  <Row>
                    <Col lg={2} md={2} sm={2} xs={2}></Col>
                    <Col
                      lg={4}
                      md={4}
                      sm={4}
                      xs={4}
                      style={{ textAlign: 'right', fontWeight: 'bold' }}
                    >
                      <div style={{ marginTop: 14 }}>
                        <h5>{activitiesBudgetSchema.expenses.totalExpensesInput.label}</h5>
                      </div>
                    </Col>
                    <Col
                      lg={16}
                      md={16}
                      sm={16}
                      xs={16}
                      style={{
                        textAlign: 'right',
                        fontWeight: 'bold',
                        borderStyle: 'none none double none',
                      }}
                    >
                      <div style={{ marginTop: 14 }}>
                        <h5
                          style={{
                            color: balanceVal >= 0 ? '#2da888' : '#a82d3d',
                          }}
                        >
                          {/* {budgetFormat(balanceVal)} */}
                          {budgetFormat(disableExpenses ? 0 : balanceVal)}
                        </h5>
                      </div>
                    </Col>
                    <Col lg={2} md={2} sm={2} xs={2} style={{ fontWeight: 'bold' }}>
                      <div style={{ marginTop: 14 }}>
                        <h5>{activitiesBudgetSchema.expenses.unitText}</h5>
                      </div>
                    </Col>
                  </Row>
                </>
              )}
            </div>
            <Row style={{ marginTop: 40 }}>
              <Col lg={4} md={4} sm={4} xs={4} style={{ textAlign: 'right' }}></Col>
              <Col lg={18} md={18} sm={18} xs={18}>
                {isReadOnly != true ? (
                  <ControlLabel
                    className={classNames(
                      isRequired(activitiesBudgetSchema.attachFiles.validators) && 'required'
                    )}
                  >
                    {!disableExpenses && balanceVal != 0 && (
                      <>{activitiesBudgetSchema.attachFiles.header}</>
                    )}
                  </ControlLabel>
                ) : (
                  <ControlLabel>{activitiesBudgetSchema.attachFiles.header}</ControlLabel>
                )}
                <ErrorMessage error={errors[activitiesBudgetSchema.attachFiles.name]} />
                {!disabled && (
                  <>
                    {!disableExpenses && balanceVal != 0 && (
                      <>
                        {!isRefash && (
                          <Controller
                            key={activitiesBudgetSchema.attachFiles.name}
                            name={activitiesBudgetSchema.attachFiles.name}
                            control={control}
                            rules={isValidators(activitiesBudgetSchema.attachFiles.validators)}
                            render={(props) => {
                              return (
                                <>
                                  <Uploader
                                    accept={
                                      activitiesBudgetSchema.attachFiles.fileType ||
                                      '.jpg, .jpeg, .png'
                                    }
                                    autoUpload={false}
                                    disabled={activitiesBudgetSchema.attachFiles.disabled}
                                    fileListVisible={true}
                                    listType="picture-text"
                                    fileList={props.value || []}
                                    onChange={(fileList) => {
                                      if (isEmpty(fileList)) {
                                        props.onChange(undefined)
                                        onRefash()
                                      } else {
                                        let file = fileList[fileList.length - 1]

                                        if (
                                          file.blobFile.size >
                                          (activitiesBudgetSchema.attachFiles?.fileSize ||
                                            defaultMaxFileSize) *
                                            1024 *
                                            1024
                                        ) {
                                          notification.open('error', {
                                            title: `ขนาดไฟล์เกิน ${
                                              activitiesBudgetSchema.attachFiles.fileSize ||
                                              defaultMaxFileSize
                                            } MB`,
                                            duration: 5000,
                                          })
                                          return
                                        }

                                        if (isImageOrPdf(file.blobFile.type)) {
                                          props.onChange([file])
                                          setFileTypeError(false)
                                        } else {
                                          setFileTypeError(true)
                                          notification.open('error', {
                                            title:
                                              'ชนิดที่รองรับ ' +
                                                activitiesBudgetSchema.attachFiles.fileType ||
                                              '.jpg, .jpeg, .png',
                                            duration: 5000,
                                          })
                                        }
                                      }
                                    }}
                                    draggable
                                  >
                                    <div>
                                      <div
                                        style={{ lineHeight: '50px' }}
                                        className={classNames('uploader', `${theme[0]}-background`)}
                                      >
                                        <Icon size="4x" icon="upload2" />
                                        <small className="uploder__text">
                                          {/* <p style={{ wordBreak: 'break-word' }}>
                                            {`คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด ชนิดที่รองรับ : .jpg, .jpeg, .png ขนาดไฟล์ไม่เกิน 50 MB`}
                                          </p> */}
                                          <p style={{ wordBreak: 'break-word' }}>
                                            {`คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด ชนิดที่รองรับ : ${
                                              activitiesBudgetSchema.attachFiles.fileType ||
                                              '.jpg, .jpeg, .png'
                                            } , ขนาดไฟล์ไม่เกิน ${
                                              activitiesBudgetSchema.attachFiles.fileSize ||
                                              defaultMaxFileSize
                                            } MB`}
                                          </p>
                                        </small>
                                      </div>
                                    </div>
                                  </Uploader>
                                </>
                              )
                            }}
                          />
                        )}
                      </>
                    )}
                  </>
                )}

                {activitiesBudgetSchema.attachFiles.values.length > 0 && (
                  <div style={{ marginTop: 10 }}>
                    <SubProjectViewFilesWidget
                      files={activitiesBudgetSchema.attachFiles.values || []}
                      buttonEye
                      buttonDownload
                      onPreviewFile={handlePreviewFile}
                      onDownloadFile={handleDownloadFile}
                    />
                  </div>
                )}
              </Col>
              <Col lg={2} md={2} sm={2} xs={2}></Col>
            </Row>

            {!disabled && (
              <Row style={{ marginTop: 10 }}>
                <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <br />
                  <SaveButton
                    disabled={isLoading}
                    // onClick={handleSubmit((data) => onSubmitBudgetForm(data, index, strKey))}

                    onClick={handleSubmit((data) => {
                      // if (sumBalanceVal < 0) {
                      //   notification.open('error', {
                      //     title: 'ค่าใช้จ่ายเกินงบประมาณคงเหลือ',
                      //     duration: 5000,
                      //   })
                      //   return
                      // }
                      onSubmitBudgetForm(data, index, strKey)
                    })}
                  >{`บันทึก`}</SaveButton>
                </Col>
              </Row>
            )}
          </Panel>
        </>
      )
    }
  }

  const addSubActivitiesForm = (addSubActivitiesSchema, index, activityId) => {
    if (addSubActivitiesSchema) {
      return (
        <>
          <Panel
            collapsible
            defaultExpanded
            bordered
            style={{ marginTop: -33 }}
            key={`${addSubActivitiesSchema.name}_${index}`}
          >
            <div style={{ paddingLeft: 45, paddingRight: 45 }}>
              <Row>
                <Col lg={4} md={4} sm={4} xs={4} style={{ textAlign: 'right' }}>
                  <div style={{ marginTop: 14 }}>
                    {isReadOnly != true ? (
                      <ControlLabel
                        className={classNames(
                          isRequired(addSubActivitiesSchema.activityNameInput.validators) &&
                            'required'
                        )}
                      >
                        {addSubActivitiesSchema.activityNameInput.label}
                      </ControlLabel>
                    ) : (
                      <ControlLabel> {addSubActivitiesSchema.activityNameInput.label}</ControlLabel>
                    )}
                  </div>
                </Col>
                <Col lg={20} md={20} sm={20} xs={20}>
                  <InputForm
                    schema={addSubActivitiesSchema.activityNameInput}
                    // value={item.link}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    hideLabel={true}
                  />
                </Col>
              </Row>

              <Row style={{ marginTop: 8 }}>
                <Col lg={4} md={4} sm={4} xs={4} style={{ textAlign: 'right' }}>
                  <div style={{ marginTop: 14 }}>
                    {isReadOnly != true ? (
                      <ControlLabel
                        className={classNames(
                          isRequired(addSubActivitiesSchema.activityStartDateInput.validators) &&
                            'required'
                        )}
                      >
                        {addSubActivitiesSchema.activityStartDateInput.label}
                      </ControlLabel>
                    ) : (
                      <ControlLabel>
                        {addSubActivitiesSchema.activityStartDateInput.label}
                      </ControlLabel>
                    )}
                  </div>
                </Col>
                <Col lg={8} md={8} sm={8} xs={8}>
                  <ErrorMessage error={errors.activityStartDateInput} />
                  <Controller
                    name={addSubActivitiesSchema.activityStartDateInput.name}
                    control={control}
                    rules={isValidators(addSubActivitiesSchema.activityStartDateInput.validators)}
                    render={(props) => {
                      return (
                        <DatePicker
                          format="DD/MM/YYYY"
                          locale={LOCAL_DAY_TH}
                          block
                          placement="auto"
                          value={props.value}
                          onChange={(value) => {
                            props.onChange(value)
                          }}
                          // disabled={!isVerification}
                        />
                      )
                    }}
                  />
                </Col>
                <Col lg={4} md={4} sm={4} xs={4} style={{ textAlign: 'right' }}>
                  <div style={{ marginTop: 14 }}>
                    {isReadOnly != true ? (
                      <ControlLabel
                        className={classNames(
                          isRequired(addSubActivitiesSchema.activityStartDateInput.validators) &&
                            'required'
                        )}
                      >
                        {addSubActivitiesSchema.activityStartDateInput.label}
                      </ControlLabel>
                    ) : (
                      <ControlLabel>
                        {addSubActivitiesSchema.activityStartDateInput.label}
                      </ControlLabel>
                    )}
                  </div>
                </Col>
                <Col lg={8} md={8} sm={8} xs={8}>
                  <ErrorMessage error={errors.activityEndDateInput} />
                  <Controller
                    name={addSubActivitiesSchema.activityEndDateInput.name}
                    control={control}
                    rules={isValidators(addSubActivitiesSchema.activityEndDateInput.validators)}
                    render={(props) => {
                      return (
                        <DatePicker
                          format="DD/MM/YYYY"
                          locale={LOCAL_DAY_TH}
                          block
                          placement="auto"
                          value={props.value}
                          onChange={(value) => {
                            props.onChange(value)
                          }}
                          // disabled={!isVerification}
                        />
                      )
                    }}
                  />
                </Col>
              </Row>

              <Row style={{ marginTop: 8 }}>
                <Col lg={4} md={4} sm={4} xs={4} style={{ textAlign: 'right' }}>
                  <div style={{ marginTop: 14 }}>
                    {isReadOnly != true ? (
                      <ControlLabel
                        className={classNames(
                          isRequired(addSubActivitiesSchema.activityStartTimeInput.validators) &&
                            'required'
                        )}
                      >
                        {addSubActivitiesSchema.activityStartTimeInput.label}
                      </ControlLabel>
                    ) : (
                      <ControlLabel>
                        {addSubActivitiesSchema.activityStartTimeInput.label}
                      </ControlLabel>
                    )}
                  </div>
                </Col>
                <Col lg={8} md={8} sm={8} xs={8}>
                  <ErrorMessage error={errors.activityStartTimeInput} />
                  <Controller
                    name={addSubActivitiesSchema.activityStartTimeInput.name}
                    control={control}
                    rules={isValidators(addSubActivitiesSchema.activityStartTimeInput.validators)}
                    render={(props) => {
                      return <DatePicker format="HH:mm" ranges={[]} block />
                    }}
                  />
                </Col>
                <Col lg={4} md={4} sm={4} xs={4} style={{ textAlign: 'right' }}>
                  <div style={{ marginTop: 14 }}>
                    {isReadOnly != true ? (
                      <ControlLabel
                        className={classNames(
                          isRequired(addSubActivitiesSchema.activityEndTimeInput.validators) &&
                            'required'
                        )}
                      >
                        {addSubActivitiesSchema.activityEndTimeInput.label}
                      </ControlLabel>
                    ) : (
                      <ControlLabel>
                        {addSubActivitiesSchema.activityEndTimeInput.label}
                      </ControlLabel>
                    )}
                  </div>
                </Col>
                <Col lg={8} md={8} sm={8} xs={8}>
                  <ErrorMessage error={errors.activityEndTimeInput} />
                  <Controller
                    name={addSubActivitiesSchema.activityEndTimeInput.name}
                    control={control}
                    rules={isValidators(addSubActivitiesSchema.activityEndTimeInput.validators)}
                    render={(props) => {
                      return <DatePicker format="HH:mm" ranges={[]} block />
                    }}
                  />
                </Col>
              </Row>

              <Row>
                <Col lg={4} md={4} sm={4} xs={4} style={{ textAlign: 'right' }}>
                  <div style={{ marginTop: 14 }}>
                    {isReadOnly != true ? (
                      <ControlLabel
                        className={classNames(
                          isRequired(addSubActivitiesSchema.locationInput.validators) && 'required'
                        )}
                      >
                        {addSubActivitiesSchema.locationInput.label}
                      </ControlLabel>
                    ) : (
                      <ControlLabel>{addSubActivitiesSchema.locationInput.label}</ControlLabel>
                    )}
                  </div>
                </Col>
                <Col lg={20} md={20} sm={20} xs={20}>
                  <InputForm
                    schema={addSubActivitiesSchema.locationInput}
                    // value={item.link}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    hideLabel={true}
                  />
                </Col>
              </Row>

              <Row>
                <Col lg={4} md={4} sm={4} xs={4} style={{ textAlign: 'right' }}>
                  <div style={{ marginTop: 14 }}>
                    {isReadOnly != true ? (
                      <ControlLabel
                        className={classNames(
                          isRequired(addSubActivitiesSchema.targetGroupInput.validators) &&
                            'required'
                        )}
                      >
                        {addSubActivitiesSchema.targetGroupInput.label}
                      </ControlLabel>
                    ) : (
                      <ControlLabel> {addSubActivitiesSchema.targetGroupInput.label}</ControlLabel>
                    )}
                  </div>
                </Col>
                <Col lg={20} md={20} sm={20} xs={20}>
                  <InputForm
                    schema={addSubActivitiesSchema.targetGroupInput}
                    // value={item.link}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    hideLabel={true}
                  />
                </Col>
              </Row>
            </div>
            {isReadOnly != true ? (
              <Row style={{ marginTop: 10 }}>
                <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <SaveButton disabled={isLoading}>{`บันทึก`}</SaveButton>
                </Col>
              </Row>
            ) : (
              <></>
            )}
          </Panel>
        </>
      )
    }
  }

  const handlePreviewFile = async (fileObj) => {
    startLoading()
    var file = await getDowloadSubProjectFilePath(fileObj.path)
    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.setAttribute('value', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const handleDownloadFile = async (fileObj) => {
    startLoading()
    var file = await getDowloadSubProjectFilePath(fileObj.path)
    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileObj?.name || 'ใบเสร็จรับเงิน')
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  return (
    <>
      {isLoading && <OverlayLoader />}
      <div style={{ paddingLeft: 50, paddingRight: 10 }}>
        <Panel header={formSchema.header} collapsible defaultExpanded bordered>
          {formSchema.activities.map((item, index) => {
            return (
              <Panel
                header={`${item?.activitiesInput?.label || ''}`}
                collapsible
                defaultExpanded
                key={index}
              >
                <div style={{ paddingLeft: 40, paddingRight: 25, marginTop: -20 }}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item?.activitiesInput?.value || '',
                    }}
                  />
                </div>

                <div style={{ paddingLeft: 40, paddingRight: 25, marginTop: 30 }}>
                  <CustomNav
                    appearance="tabs"
                    active={active}
                    onSelect={(e) => {
                      handleSelect(e, item.activitiesDetail, index)
                    }}
                    subSchema={item.activitiesDetail}
                    tabs={index}
                    key={index}
                  />

                  {index == activitiesIndex &&
                    activitiesTabSelected == 'activitiesResult' &&
                    activitiesResultForm(
                      activitiesItem,
                      activitiesIndex,
                      item.id,
                      'activitiesResult'
                    )}

                  {index == activitiesIndex &&
                    activitiesTabSelected == 'activitiesImage' &&
                    activitiesImageForm(
                      activitiesItem,
                      activitiesIndex,
                      item.id,
                      'activitiesImage'
                    )}

                  {index == activitiesIndex &&
                    activitiesTabSelected == 'activitiesBudget' &&
                    activitiesBudgetForm(
                      activitiesItem,
                      activitiesIndex,
                      item.id,
                      'activitiesBudget'
                    )}
                  {/* {item.activitiesDetail[0]?.mentionOfmentor?.value || '88'}
                  {console.log(
                    'mentionOfmentor===>',
                    item.activitiesDetail[0]?.mentionOfmentor?.value
                  )} */}
                  <Row>
                    {item.activitiesDetail[0]?.mentionOfmentor?.value && (
                      <div style={{ marginTop: 14 }}>
                        {/* <b>{`${activitiesResultSchema?.mentionOfmentor?.label || ''}`}</b> */}
                        {/* <p>{`${activitiesResultSchema?.mentionOfmentor?.value || ''}`}</p> */}
                        <Message
                          type="warning"
                          showIcon
                          style={{ marginTop: 10 }}
                          // description={activitiesResultSchema?.mentionOfmentor?.value}
                          description={`ความเห็นพี่เลี้ยง : ${item.activitiesDetail[0]?.mentionOfmentor?.value}`}
                        />
                      </div>
                    )}
                  </Row>
                </div>
              </Panel>
            )
          })}
        </Panel>
      </div>
    </>
  )
}
